export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg3.0839907a.png";